(ns practitest.frontend.forms3.entity-form.traceability-linked-entity-columns
  (:require    [practitest.frontend.components2.grid.fields :refer [transform-fields]]
               [practitest.frontend.components2.issue-status :as issue-status]
               [practitest.frontend.components2.requirement-testing-status :as requirement-testing-status]
               [practitest.frontend.components2.run-status :as run-status]
               [practitest.frontend.components.grid.subs :as grid.subs]
               [practitest.frontend.forms3.entity-form.testset-instances-columns :as testset-instances-columns]))

(defmethod grid.subs/columns :linked-issues-traceability-grid [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (->> [{:type           :linked-entities
         :field          :linked_milestones
         :default-width  80
         :default-show?  true
         :autofilter?    true
         :header         "Milestones"}
        {:type          :linked-entities
         :default-width 200
         :autofilter?   false
         :sortable?     false
         :header        "Linked Tests"
         :field         :linked_tests}
        {:type          :linked-entities
         :default-width 200
         :autofilter?   false
         :sortable?     false
         :header        "Linked Requirements"
         :field         :linked_requirements}
        {:type           :display_id
         :field          :external_id
         :default-width  120
         :default-show?  false
         :autofilter?    true
         :header         "External ID"}]
       (concat (transform-fields [:issue_status :priority :updated_at :assigned_to]
                                 (dissoc (:issue entity-fields) :description :linked_milestones)
                                 fields users groups folders))
       (remove (fn [column] (#{"Tags"
                               "Summary"
                               "Status"} (:header column))))))


(defmethod grid.subs/columns :linked-requirements-traceability-grid [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (->> [{:type           :linked-entities
         :field          :linked_milestones
         :default-width  80
         :default-show?  true
         :autofilter?    true
         :header         "Milestones"}
        {:type          :linked-entities
         :default-width 200
         :autofilter?   false
         :sortable?     false
         :header        "Linked Tests"
         :field         :linked_tests}
        {:type          :linked-entities
         :default-width 200
         :autofilter?   false
         :sortable?     false
         :header        "Linked Issues"
         :field         :linked_issues}
        {:type          :status-bar
         :default-width 200
         :autofilter?   false
         :sortable?     false
         :header        "Requirement Status Bar"
         :field         :requirement_status_bar}
        {:type          :testing-scope
         :default-width 200
         :autofilter?   true
         :sortable?     true
         :header        "Testing Scope"
         :field         :testing_scope}
        {:type           :display_id
         :field          :external_id
         :default-width  120
         :default-show?  false
         :autofilter?    true
         :header         "External ID"}]
       (concat (transform-fields [:updated_at]
                                 (dissoc (:requirement entity-fields) :description :linked_milestones)
                                 fields users groups folders))
       (remove (fn [column] (#{"Tags" "Testing Status"} (:header column))))))

(defmethod grid.subs/columns :linked-tests-traceability-grid [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  (->> [{:type :test_type
         :field :test_type
         :header "Type"
         :autofilter? true}
        {:type          :linked-entities
         :default-width 200
         :autofilter?   false
         :sortable?     false
         :header        "Linked Issues"
         :field         :linked_issues}
        {:type          :linked-entities
         :default-width 200
         :autofilter?   false
         :sortable?     false
         :header        "Linked Requirements"
         :field         :linked_requirements}
        {:type          :linked-entities
         :default-width 200
         :header        "Linked Test Sets"
         :autofilter?   false
         :sortable?     false
         :field         :linked_testsets}
        {:type          :number
         :field         :steps_count
         :autofilter?   true
         :text-align    "center"
         :multiple?     true
         :sortable?     true
         :header        "Steps Count"}]
       (concat (transform-fields []
                                 (dissoc (:test entity-fields) :description :test_type)
                                 fields users groups folders))
       (remove (fn [column] (#{"Tags"
                               "Run Status"
                               "Last Run"
                               "Script repository"
                               "# of result files to upload"
                               "Script path"
                               "Automated test design"
                               "Charter" "Guide Points"
                               "Results path"
                               "Duration Average"
                               "Client id"
                               "Scenario"} (:header column))))))

(defmethod grid.subs/columns :linked-requirement-children-traceability-grid [[_current-project entity-fields fields users groups folders] [_ [_entity _]]]
  [{:type :user,
    :field :author,
    :systemcol? true
    :default-width 120,
    :autofilter? false,
    :sortable? false,
    :default-show? true,
    :header "Author"}
   {:type :date-time,
    :field :created_at,
    :systemcol? true
    :default-width 120,
    :autofilter? false,
    :sortable? false,
    :default-show? true,
    :header "Created"}
   {:type :testing-scope,
    :field :testing_scope,
    :systemcol? true
    :default-width 150,
    :autofilter? false,
    :sortable? false,
    :default-show? true,
    :header "Testing Scope"}
   {:type :list,
    :field :requirement_status,
    :systemcol? true
    :default-width 150,
    :autofilter? false,
    :sortable? false,
    :default-show? true,
    :header "Testing Status"
    :possible-values (vec (keys requirement-testing-status/statuses-map))
    :multiple? true}
   {:type :user,
    :field :assigned_to,
    :systemcol? true
    :default-width 120,
    :autofilter? false,
    :sortable? false,
    :default-show? true,
    :header "Assigned To"}])

(defn get-pre-columns-by-type [requirement-children-entity?
                               test-entity?
                               issue-entity?
                               requirement-entity?
                               call-to-test?
                               ancestor-info?
                               testset-linked?]
    (concat [{:type :display_id,
              :field :display_id,
              :systemcol? true
              :default-width 80,
              :autofilter? true,
              :default-show? true,
              :header "ID"}
             {:type :internal-url,
              :field :name,
              :systemcol? true
              :default-width 80,
              :autofilter? true,
              :default-show? true,
              :header "Name"}]
          (when (and test-entity? testset-linked?)
            [{:type :custom-field-url
              :field :test_instance
              :default-width 250,
              :autofilter? true,
              :default-show? true,
              :systemcol? true
              :header "Test Instance in Test Set"}
             {:type :text
              :field :last_run_date
              :default-width 100,
              :autofilter? true,
              :default-show? true,
              :systemcol? true
              :header "Last Run: Date"}])
          (when test-entity?
            [{:default-width 100,
              :default-show? true,
              :systemcol? true,
              :field :last_run,
              :type :date-time,
              :header "Last Run",
              :autofilter? true}
             {:default-width 200,
              :default-show? true,
              :systemcol? true,
              :field :run_status,
              :type :run_status,
              :header "Run Status",
              :possible-values (vec (keys run-status/statuses-map))
              :multiple? true,
              :autofilter? true}])
          (when issue-entity?
            [{:default-width 200,
              :default-show? true,
              :systemcol? true,
              :field :issue_status,
              :type :list,
              :header "Status",
              :possible-values (vec (keys issue-status/statuses-map))
              :multiple? true,
              :autofilter? true}])
          (when requirement-entity?
            [{:default-width 200,
              :default-show? true,
              :systemcol? true,
              :field :requirement_status,
              :type :list,
              :header "Status",
              :possible-values (vec (keys requirement-testing-status/statuses-map)),
              :multiple? true,
              :autofilter? true}])
          (when (or call-to-test?
                    ancestor-info?)
            [{:default-width 200,
              :default-show? true,
              :systemcol? true,
              :field :run_status,
              :type :run_status,
              :header "Run Status",
              :possible-values (vec (keys run-status/statuses-map))
              :multiple? true,
              :autofilter? true}])))

(defmethod grid.subs/columns :linked-testsets-traceability-grid [[_current-project _entity-fields _fields _users _groups _folders] [_ [_entity _]]]
  (testset-instances-columns/get-testset-instance-columns))

(defn get-pre-columns [linked-entities-key-plural testset-linked?]
  (let [test-entity? (= linked-entities-key-plural :tests)
        issue-entity? (= linked-entities-key-plural :issues)
        requirement-entity? (= linked-entities-key-plural :requirements)
        call-to-test? (= linked-entities-key-plural :called_by_ctts)
        ancestor-info? (= linked-entities-key-plural :ancestor_info)
        requirement-children-entity? (= linked-entities-key-plural :requirement_children)
        testset-entity? (= linked-entities-key-plural :testsets)]
    (if testset-entity?
      []
      (let [pre-columns (get-pre-columns-by-type requirement-children-entity?
                                                  test-entity?
                                                  issue-entity?
                                                  requirement-entity?
                                                  call-to-test?
                                                  ancestor-info?
                                                  testset-linked?)]
        (remove nil? pre-columns)))))